function About() {
  return (
    <section id="about" className="section about">

      <div className="section-title">

        <p>WHO WE ARE</p>

        <h2>About Us</h2>

      </div>

      <div className="about-content">

        <div>

          <h3>
            Software Development & Industrial Automation
          </h3>

          <p>
            We are a technology and engineering solutions company
            providing Software Development, Industrial Automation,
            Project Commissioning, Technical Support and Professional
            Training.
          </p>

          <p>
            Our team combines software development expertise with
            industrial automation experience to provide practical,
            reliable and customized solutions.
          </p>

        </div>

        <div className="experience">

          <div className="experience-card">
            <h2>10+</h2>
            <p>Years Automation Experience</p>
          </div>

          <div className="experience-card">
            <h2>4+</h2>
            <p>Years Software Experience</p>
          </div>

          <div className="experience-card">
            <h2>100%</h2>
            <p>Practical Training</p>
          </div>

        </div>

      </div>

    </section>
  );
}

export default About;